import React from 'react';

import { IsMobile } from '../../helpers/IsMobile';
import MobileNavigation from '../MobileNavigation/MobileNavigation';
import SideMenu from '../SideMenu/SideMenu';

const NavigationBar = ({ isIOSDevice }) => {
  const isMobile = IsMobile();
  return isMobile ? <MobileNavigation isIOSDevice={isIOSDevice} /> : <SideMenu isIOSDevice={isIOSDevice} />;
};

export default NavigationBar;
